<template>
  <div class="home_banner" v-if="list.length>0">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="like_slide" v-for="(item,index) in list" :key="index">
        <a v-if="item.ClickType==0" :href="item.ClickUrl" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'"></a>
        <router-link v-if="item.ClickType==2" :to="{path:'/carddetails/'+item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
        </router-link>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';
import { getInfo } from "@/api/public";

export default {
  name: 'likeswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      userInfo: '',
      list: '',
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      }
    }
  },

  created() {
    this.userInfo = getInfo();
    this.abc()
  },
  methods: {
    abc() {
      let that = this;
      let data = { AreaID: 'US', bannerType: 1, AdType: 1 }
      this.$get(this.$interface.GetAdvertisement, data).then(res => {
        console.log(res)
        if (res.result != 0) {
          that.list = res.data
        }
      })
    }
  }
}

</script>
<style scoped>
.home_banner {
  width: 1200px;
  overflow: hidden;
  margin: auto;
}

.swiper {
  width: 100%;
  height: 240px;
}

.like_slide,
.like_slide .bannerDiv {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: block;
}
/deep/ .swiper-pagination-bullet{
  width: 10px;
  height: 10px;
  opacity: 1;
  background: #ccc;
}
/deep/ .swiper-pagination-bullet-active{
  background: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/advertisement.vue